<template lang="pug">
    Modal
        .form
            h2 Are you sure you would like to delete this?
            .button-container
                button.button__action(
                    @click="deleteRecord"
                ) Yes
                button.button__action.button__delete(
                    @click="closeModal"
                ) Cancel
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import {postResource} from '../../services/Utils';
export default {
    name: 'DeleteRecordModal',
    components: {
        Modal
    },
    computed: {
        recordPath(){
            if(this.$route.name === 'policyTemplate') {
                return 'policies';
            }

            if(this.$route.name === 'sequenceTemplate') {
                return 'sequences';
            }

            if(this.$route.name === 'cardTemplate') {
                return 'actioncards';
            }
        },
        redirectTo(){
            if(this.$route.name === 'policyTemplate') {
                return '/policies';
            }

            if(this.$route.name === 'sequenceTemplate') {
                return '/sequences';
            }

            if(this.$route.name === 'cardTemplate') {
                return '/cards';
            }
        }
    },
    methods: {
        deleteRecord(){
            // determine record type
            const update = {
                deleted: true,
                _id: this.$route.params.shortId
            }

            postResource(`/v1/${this.recordPath}/delete`, false, update)
                .then((res) => {
                    console.log(res);
                    this.$router.push(this.redirectTo);
                }).catch((err) => {
                    console.log(err);
                })

            // send delete to delete endpoint with record Id and record type

            // close modal and redirect
        },
        closeModal() {
            store.commit('hideModals', true);
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

.button-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    max-width: 200px;
    margin: auto;
}

button {
    margin: 2rem auto 0;
    /* text-transform: uppercase; */
}
</style>



// WEBPACK FOOTER //
// src/components/modals/DeleteRecord.vue